import { Component, Input, inject } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { UploadDocumentModalComponent } from '../upload-document-modal/upload-document-modal.component';

@Component({
  selector: 'lib-upload-document-button',
  templateUrl: './upload-document-button.component.html',
  styleUrls: ['./upload-document-button.component.scss'],
  imports: [IonIcon, IonButton, TranslateModule],
})
export class UploadDocumentButtonComponent {
  private readonly modalCtrl = inject(ModalController);

  @Input()
  documentType: any;

  async showUploadDocumentModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: UploadDocumentModalComponent,
      componentProps: {
        documentType: this.documentType,
      },
      backdropDismiss: false,
    });
    modal.present();
  }
}
